<script setup>
import { onMounted, ref } from 'vue'
import Menu from '../components/Menu'
import { Gems } from '../gems'
import { HUB } from '../hub'

const logoSrc = ref('')
const logoFileRef = ref(null)

async function Initialize() {
    const togglePhotoPermission = document.getElementById('photo-permission')

    const responsePermissions = await HUB.CallBackEnd({ action: HUB.Action("get-app-permissions") })

    SetToggleState(togglePhotoPermission, responsePermissions.data.upload_photo)

    if (responsePermissions.data.logo && responsePermissions.data.photo_location) {
        logoSrc.value = responsePermissions.data.photo_location.replace(/\/?$/, '/') + responsePermissions.data.logo
    }
}

function TriggerLogoUpload() {
    logoFileRef.value?.click()
}

async function UploadLogo(e) {
    const file = e.target.files[0]
    if (!file) return

    const formData = new FormData()
    formData.append('file', file)

    const response = await HUB.CallBackEnd({ action: HUB.Action("upload-company-logo"), data: formData })

    if (logoFileRef.value) logoFileRef.value.value = ''
    if (response.error) return

    logoSrc.value = response.data.logo_url
}

async function RemoveLogo() {
    const response = await HUB.CallBackEnd({ action: HUB.Action("remove-company-logo") })

    if (response.error) return

    logoSrc.value = ''
}

async function Toggle(elem) {
    ToggleControl(elem)
        const permissionState = Number(elem.classList.contains('fa-toggle-on'))
        const response = await HUB.CallBackEnd({ action: HUB.Action("upload-photo-permission"), data: { permissionState } })
        if (response.error)
            Gems.Telegram(response.message, 'tele-not-allowed')
}

function ToggleControl(elem) {
    if (elem.classList.contains('fa-toggle-off')) {
        SetToggleState(elem, true)
    } else {
        SetToggleState(elem, false)
    }
}

function SetToggleState(element, state) {
    if (Number(state)) {
        element.classList.remove('fa-toggle-off')
        element.classList.add('fa-toggle-on')
        return
    }
    element.classList.remove('fa-toggle-on')
    element.classList.add('fa-toggle-off')
}

onMounted(() => {
    Initialize()
})

</script>


<template>
    <div id="div-container" class="main-container-background">
        <Menu></Menu>
        <div class="page-container">
            <img class="img-inpeople-default" src="../images/inpeople.png">

            <div class="logo-section">
                <!--<div class="label logo-label">Logotipo da empresa</div>-->
                <input type="file" ref="logoFileRef" @change="UploadLogo" accept="image/jpeg, image/png, .jpg, .jpeg, .png" class="inputfile" />
                <div class="logo-area cursor-pointer" @click="TriggerLogoUpload" @mouseenter="Gems.Tooltip($event.target, `Logotipo da empresa`, 'tooltip')">
                    <img v-if="logoSrc" :src="logoSrc" class="logo-img" />
                    <span v-else class="logo-placeholder-text">Logotipo da empresa</span>
                    <div v-if="logoSrc" class="logo-trash" @click.stop="RemoveLogo">
                        <i class="fa fa-trash"></i>
                    </div>
                </div>
            </div>

            <div>
                <div class="div-row">
                    <i id="photo-permission" class="toggle-icon fa fa-toggle-off" @click="Toggle($event.target)"></i>
                    <div class="div-label label">Utilizadores podem carregar a foto de perfil</div>
                </div>
            </div>
        </div>
    </div>
</template>


<style scoped>
#div-container {
    display: flex;
    min-height: 100vh;
}

.page-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 25px 35px 25px 14px;
}

.img-inpeople-default { 
    margin-bottom: 27px;
}

.div-row {
    display: flex;
    align-items: center;
}

.toggle-icon {
    font-size: 1.3em;
    cursor: pointer;
    margin-right: 15px;
}

.inputfile {
    display: none;
}

.logo-section {
    margin-bottom: 27px;
}

.logo-area {
    position: relative;
    height: 165px;
    width: 300px;
    border: 2px solid #fff;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    cursor: pointer;
}

.logo-img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.logo-placeholder-text {
    color: #fff;
    font-size: 0.95em;
    text-align: center;
    pointer-events: none;
    opacity: 0.7;
    padding: 10px;
}

.logo-trash {
    display: none;
    position: absolute;
    bottom: 8px;
    right: 8px;
    background: rgba(0, 0, 0, 0.6);
    color: #fff;
    width: 28px;
    height: 28px;
    border-radius: 4px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.logo-area:hover .logo-trash {
    display: flex;
}

.logo-trash:hover {
    background: rgba(180, 0, 0, 0.85);
}

.logo-label {
    margin-top: 6px;
}

</style>